<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/8dD382/tc-custom/9781429965224.jpg?1731007758009" alt="This image is the cover for the book Street Magic, The Black London Novels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Street Magic, The Black London Novels
      </h1>
      <p class="bookDescription body article font2">
        <b>“This dark tale takes supernatural shadows to the next level . . . [Kittredge’s] fans will enjoy the mix of magic and city grit.” —<i>Publishers Weekly</i></b><br/><br/>Her name is Pete Caldecott. She was just sixteen when she met Jack Winter, a gorgeous, larger-than-life mage who thrilled her with his witchcraft. Then a spirit Jack summoned killed him before Pete’s eyes—or so she thought. Now a detective, Pete is investigating the case of a young girl kidnapped from the streets of London. A tipster’s chilling prediction has led police directly to the child . . . but when Pete meets the informant, she’s shocked to learn he is none other than Jack. Strung out on heroin, Jack’s a shadow of his former self. But he’s able to tell Pete exactly where Bridget’s kidnappers are hiding: in the supernatural shadow-world of the fey. Even though she’s spent years disavowing the supernatural, Pete follows Jack into the invisible fey underworld, where she hopes to discover the truth about what happened to Bridget—and what happened to Jack on that dark day so long ago . . .<br/><br/>“Atmospheric and filled with a gritty realism . . . the novel crackles with conflict and perilous magic. For those who love their urban fantasy hypnotically treacherous, this book’s for you!” —<i>Romantic Times</i><br/><br/>“Kittredge introduces readers to the dark side of life and magic in a well-formed fictional world with characters that you can’t help but like.” —<i>Darque</i> Reviews
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Caitlin Kittredge
      </h2>
      
      <p class="authorDescription body article"><P><B>Caitlin Kittredge</B> is the author of the Nocturne City and Black London series, as well as several short stories. She started writing novels at age 13, and after a few years writing screenplays, comic books and fan-fiction, she wrote <I>Night Life</I>, her debut novel. She is the proud owner of an English degree, two cats, a morbid imagination, a taste for black clothing, punk rock, and comic books. She's lucky enough to write full time and watches far too many trashy horror movies. She lives in Olympia, Washington.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?234df4be